import { OWebPageBase } from "oweb";
import PHomeComponent from "@/components/pages/PHome.vue";
import { VueConstructor } from 'vue';

export default class PHome extends OWebPageBase<VueConstructor> {
	getName() {
		return "PHome"
	}

	getRoutes() {
		return [ {
			title: "SX_LANG_HOME",
			slug: "w-home-menu",
			path: "/"
		}, {
			title: "SX_LANG_ABOUT",
			slug: "w-home-about",
			path: "/about"
		}, {
			title: "SX_LANG_SECTORS",
			slug: "w-sectors-list",
			path: "/sectors"
		}, {
			title: "SX_LANG_COMPANIES_FIND",
			slug: "w-companies-search",
			path: "/companies/search"
		}, {
			title: "SX_LANG_SURVEYS_FIND",
			slug: "w-surveys-search",
			path: "/surveys/search"
		} ];
	}

	getComponent() {
		return PHomeComponent
	}
}